module.exports = __webpack_public_path__ + "img/TheAncientOreNew.9ff55e21.png";